import { Outlet, useLocation } from 'react-router-dom';

import { Avatar } from '../components_catalyst/avatar';
import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from '../components_catalyst/dropdown';
import {
  Navbar,
  NavbarDivider,
  NavbarItem,
  NavbarLabel,
  NavbarSection,
  NavbarSpacer,
} from '../components_catalyst/navbar';
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
} from '../components_catalyst/sidebar';
import { StackedLayout } from '../components_catalyst/stacked-layout';
import {
  ArrowRightStartOnRectangleIcon,
  ChevronDownIcon,
  Cog8ToothIcon,
  LightBulbIcon,
  PlusIcon,
  ShieldCheckIcon,
  UserIcon,
} from '@heroicons/react/16/solid';
import { InboxIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { useAuth } from '../components_auth/AuthContext';

export function UnauthenticatedStackedLayout() {
  const { user } = useAuth();
  const location = useLocation();
  const navItems = [
    { label: 'Home', url: '/' },
    { label: 'Membership', url: '/membership' },
    { label: 'Contact', url: '/contact' },
  ];

  return (
    <StackedLayout
      navbar={
        <Navbar role="banner" aria-label="Top navigation">
          <NavbarItem href="/">
            <Avatar square src="/logo50x50.png" alt="MilestoneMap.org logo" />
            <NavbarLabel>MilestoneMap.org</NavbarLabel>
          </NavbarItem>
          <NavbarDivider className="max-lg:hidden" />
          <NavbarSection role="navigation" aria-label="Main navigation" className="max-lg:hidden">
            {navItems.map(({ label, url }) => (
              <NavbarItem
                key={label}
                href={url}
                current={location.pathname === url}
                aria-current={location.pathname === url ? 'page' : undefined}
              >
                {label}
              </NavbarItem>
            ))}
          </NavbarSection>
          <NavbarSpacer />
          {user ? (
            <NavbarSection role="navigation" aria-label="User menu">
              <NavbarItem href="/sign-out">Sign out</NavbarItem>
            </NavbarSection>
          ) : (
            <NavbarSection role="navigation" aria-label="Authentication">
              <NavbarItem
                href="/sign-in"
                aria-label="Sign in"
                current={location.pathname === '/sign-in'}
                aria-current={location.pathname === '/sign-in' ? 'page' : undefined}
              >
                Sign in
              </NavbarItem>
              <NavbarDivider className="max-lg:hidden" />
              <NavbarItem
                href="/sign-up"
                aria-label="Sign up"
                current={location.pathname === '/sign-up'}
                aria-current={location.pathname === '/sign-up' ? 'page' : undefined}
              >
                Sign up
              </NavbarItem>
            </NavbarSection>
          )}
        </Navbar>
      }
      sidebar={
        <>
          {/* This button is always in the DOM but only visible to screen readers */}
          <button
            type="button"
            onClick={() => {
              /* TODO: Add sidebar open handler */
            }}
            className="sr-only"
            role="navigation"
            aria-label="Open main navigation menu"
            aria-expanded="false"
          >
            Open navigation menu
          </button>
          <Sidebar role="navigation" aria-label="Main navigation">
            <SidebarHeader>
              <Dropdown>
                <DropdownButton as={SidebarItem} className="lg:mb-2.5">
                  <Avatar square src="/logo50x50.png" alt="MilestoneMap.org logo" />
                  <SidebarLabel>MilestoneMap.org</SidebarLabel>
                  <ChevronDownIcon aria-hidden="true" />
                </DropdownButton>
              </Dropdown>
            </SidebarHeader>
            <SidebarBody>
              <SidebarSection>
                {navItems.map(({ label, url }) => (
                  <SidebarItem
                    key={label}
                    href={url}
                    current={location.pathname === url}
                    aria-current={location.pathname === url ? 'page' : undefined}
                  >
                    {label}
                  </SidebarItem>
                ))}
              </SidebarSection>
            </SidebarBody>
          </Sidebar>
        </>
      }
    >
      <Outlet />
    </StackedLayout>
  );
}
